export const EMPTY = 'empty';
export const LOADING = 'loading';
export const SUCCESS = 'success';
export const WARNING = 'warning';
export const ERROR = 'error';